import { render } from "./home.vue?vue&type=template&id=b8a2d402&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=b8a2d402&scoped=true&lang=css"

import exportComponent from "/Users/min/Desktop/lambda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a2d402"]])

export default __exports__